import { Button, ButtonProps } from "@/components/ui/button"
import { cn } from "@/lib/utils"

interface FormViewActionsProps {
  submitting: boolean
  onCancel: () => void
  cancelButtonProps?: Partial<ButtonProps>
  confirmButtonProps?: Partial<ButtonProps>
  className?: string
}

function FormViewActions(props: FormViewActionsProps) {
  return (
    <div className={cn("flex items-center justify-end gap-3", props.className)}>
      <Button type="button" size="lg" variant="outline" className="border-2 w-24" onClick={props.onCancel} {...props.cancelButtonProps}>
        Cancel
      </Button>
      <Button type="submit" size="lg" loading={props.submitting} className="min-w-[81px]" {...props.confirmButtonProps}>
        {props.confirmButtonProps?.children || "Save"}
      </Button>
    </div>
  )
}

export default FormViewActions
